import axios from "axios";
import logger from "./logService";
import { toast } from "react-toastify";
import session from "./sessionService";

export function isProtectedApiRequest( error )
{
    const url = error.config && error.config.url;
    return typeof url === "string" && url.indexOf( "/api/" ) !== -1;
}

export function handleHTTPError( error, browserLocation = window.location )
{
    if ( error.response && error.response.status === 401 && isProtectedApiRequest( error ) )
    {
        session.clearStoredToken();
        setJwt( null );
        browserLocation.href = "/w/login";
    }
    const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;

    if ( !expectedError )
    {
        logger.log( error );
        toast.error( "Belső hiba történt!" );
    }

    return Promise.reject( error );
}

axios.interceptors.response.use( null, error => handleHTTPError( error ) );

export function setJwt( jwt )
{
    if ( jwt )
    {
        axios.defaults.headers.common[ "Authorization" ] = `Bearer ${ jwt }`;
        return;
    }

    delete axios.defaults.headers.common[ "Authorization" ];
}

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    setJwt
};
